// Components/DraftsPage/WordProcessorTab.js
import { useReducer } from "react";
import { useCallback } from "react";

import WPGenerateDocumentDraftPage from "@/Components/WordProcessor/WPGenDocumentDraftPage";

import WPDiscoveryDraft from "../../WordProcessor/WPDiscoveryDraft";
import WPCourtForm from "../../WordProcessor/WPCourtForm";

const WordProcessorTab = ({
  tab,
  setPageNumber,
  setTotalPages,
  container,
  setTabCollab = () => {},
  handleCloseTab,
}) => {
  const initialState = {
    filename: "",
    updatedFileName: "",
    show: false,
    loading: true,
    error: false,
    status: "",
    draftId: "",
    tempName: "",
  };

  function reducer(state, action) {
    switch (action.type) {
      case "SET_LOADING":
        return { ...state, loading: action.payload };
      case "SET_ERROR":
        return { ...state, error: action.payload };
      case "SET_FILENAME":
        return { ...state, filename: action.payload };
      case "SET_UPDATED_FILENAME":
        return { ...state, updatedFileName: action.payload };
      case "SHOW_MODAL":
        return { ...state, show: true, status: action.payload };
      case "HIDE_MODAL":
        return { ...state, show: false };
      case "SET_DRAFT_ID":
        return { ...state, draftId: action.payload };
      case "SET_TEMP_NAME":
        return { ...state, tempName: action.payload };
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  const reportCollab = useCallback(
    (isCollab) => setTabCollab?.(tab.id, isCollab),
    [setTabCollab, tab.id]
  );
  const renderContent = () => {
    switch (tab.type) {
      case "Draft":
        return (
          <WPGenerateDocumentDraftPage
            updatedDocId={null}
            docId={tab.docId}
            dynamicTemplateId={tab.dynamicTemplateId}
            dispatch={dispatch}
            draftId={tab.draftId}
            state={state}
            fetchEditDocs={() => {}}
            type={tab.type}
            isFromLetterPopup={false}
            container={container}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
            height={0}
            setTabCollab={reportCollab}
            handleCloseTab={handleCloseTab}
          />
        );
      case "GenerateDocument":
        return (
          <WPGenerateDocumentDraftPage
            updatedDocId={null}
            docId={tab.docId}
            dynamicTemplateId={tab.dynamicTemplateId}
            dispatch={dispatch}
            draftId={tab.draftId}
            state={state}
            fetchEditDocs={() => {}}
            type={tab.type}
            isFromLetterPopup={false}
            container={container}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
            height={0}
            setTabCollab={reportCollab}
            handleCloseTab={handleCloseTab}
          />
        );
      case "DiscoveryDraft":
        return (
          <WPDiscoveryDraft
            updatedDocId={null}
            docId={tab.docId}
            dynamicTemplateId={tab.dynamicTemplateId}
            dispatch={dispatch}
            draftId={tab.draftId}
            state={state}
            fetchEditDocs={() => {}}
            type={tab.type}
            litigationId={tab.litigationId}
            showRightSidebar={false}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      case "CourtForm":
        return (
          <WPCourtForm
            updatedDocId={null}
            docId={tab.docId}
            courtFormId={tab.courtFormId}
            dispatch={dispatch}
            draftId={tab.draftId}
            state={state}
            fetchEditDocs={() => {}}
            type={tab.type}
            litigationId={tab.litigationId}
            showRightSidebar={false}
            setPageNumber={setPageNumber}
            setTotalPages={setTotalPages}
          />
        );
      default:
        return <p>Unknown document type</p>;
    }
  };

  return <>{renderContent()}</>;
};

export default WordProcessorTab;
